module.exports = __webpack_public_path__ + "static/media/system.adb77b3b.wav";